import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

import { commonContentAttributes } from "./commonContentAttributes";

export const mal_vb_j: SugarElementInfo = {
    name: "mal_vb_j",
    availableChildren: { type: AvailableChildrenType.Any },
    attributes: commonContentAttributes,
};
